<template>
  <div class="precios-modelos-v2">
    <v-row class="d-flex justify-center mt-0">
      <v-col cols="12">
        <!-- Título y acciones principales -->
        <v-card class="mb-4" elevation="1">
          <v-card-title class="text-h5 py-3 d-flex align-center flex-wrap">
            <v-icon left color="primary">fas fa-tags</v-icon>
            Precios por modelo (Planes de Ahorro)
            <v-spacer />
            <v-btn
              color="success"
              small
              fab
              class="mr-2"
              title="Nuevo precio"
              @click="abrirModalNuevo"
            >
              <v-icon>fas fa-plus</v-icon>
            </v-btn>
            <v-btn
              color="warning"
              small
              fab
              class="mr-2"
              title="Carga masiva"
              @click="modalCargaMasiva = true"
            >
              <v-icon>fas fa-layer-group</v-icon>
            </v-btn>
            <v-btn
              color="primary"
              small
              fab
              title="Gestionar modelos"
              @click="modalModelos = true"
            >
              <v-icon>fas fa-car</v-icon>
            </v-btn>
          </v-card-title>
        </v-card>

        <!-- Filtros -->
        <v-card class="mb-4" elevation="1">
          <v-card-title class="subtitle-1 py-2 d-flex align-center" @click="panelFiltros = !panelFiltros">
            <v-icon left>fas fa-filter</v-icon>
            Filtros
            <v-spacer />
            <v-icon>{{ panelFiltros ? 'fas fa-chevron-up' : 'fas fa-chevron-down' }}</v-icon>
          </v-card-title>
          <v-expand-transition>
            <v-card-text v-show="panelFiltros" class="pt-0">
              <v-form @submit.prevent="buscar">
                <v-row dense>
                  <v-col cols="12" sm="6" md="3" class="py-2">
                    <v-autocomplete
                      v-model="filtro.empresa"
                      label="Empresa"
                      :items="familias"
                      item-text="nombre"
                      return-object
                      hide-details
                      outlined
                      dense
                      placeholder="Seleccione empresa"
                      @change="onEmpresaChange"
                    />
                  </v-col>
                  <v-col cols="12" sm="6" md="3" class="py-2">
                    <v-autocomplete
                      v-model="filtro.marcas"
                      label="Marcas"
                      :items="marcasEmpresa"
                      item-text="nombre"
                      item-value="id"
                      :disabled="!filtro.empresa || !filtro.empresa.id"
                      hide-details
                      outlined
                      dense
                      multiple
                      chips
                      small-chips
                      clearable
                      deletable-chips
                      placeholder="Todas"
                      @change="onMarcasChange"
                    />
                  </v-col>
                  <v-col cols="12" sm="6" md="3" class="py-2">
                    <v-autocomplete
                      v-model="filtro.modelos"
                      label="Modelos"
                      :items="modelosParaFiltro"
                      item-text="nombre"
                      item-value="Modelo_id"
                      :disabled="!filtro.empresa || !filtro.empresa.id"
                      hide-details
                      outlined
                      dense
                      multiple
                      chips
                      small-chips
                      clearable
                      deletable-chips
                      placeholder="Todos"
                    />
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="12" sm="6" md="2" class="py-2">
                    <FechaPicker v-model="filtro.desde" label="Desde" hide-details clearable />
                  </v-col>
                  <v-col cols="12" sm="6" md="2" class="py-2">
                    <FechaPicker v-model="filtro.hasta" label="Hasta" hide-details clearable />
                  </v-col>
                  <v-col cols="12" class="d-flex align-center flex-nowrap py-2">
                    <BtnFiltro :loading="loading" clase="mt-0" @clear="limpiarFiltro" />
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-expand-transition>
        </v-card>

        <!-- Tabla -->
        <v-card elevation="2">
          <v-data-table
            class="cebra"
            item-key="precio_id"
            :headers="headers"
            :items="preciosModelos"
            :loading="loading"
            :search="buscadoRapido"
            sort-by="fecha_desde"
            sort-desc
            dense
            no-data-text="Seleccione empresa y pulse Buscar. Si no hay marcas, elija al menos una marca."
          >
            <template v-slot:top>
              <v-row class="px-2 py-2" align="center" justify="space-between">
                <v-col cols="12" md="4">
                  <SearchDataTable v-model="buscadoRapido" />
                </v-col>
                <v-col cols="12" md="4" class="d-flex justify-end">
                  <v-btn color="primary" small class="mr-3" :disabled="!puedeSubir" @click="abrirSubir">
                    <v-icon left small>fas fa-file-upload</v-icon>
                    Subir
                  </v-btn>
                  <v-btn color="success" small class="ml-1" :disabled="preciosModelos.length === 0" @click="descargar">
                    <v-icon left small>fas fa-file-download</v-icon>
                    Descargar
                  </v-btn>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.fecha_desde`]="{ value }">
              {{ value ? formatDate(value) : '—' }}
            </template>
            <template v-slot:[`item.fecha_hasta`]="{ value }">
              {{ value ? formatDate(value) : '—' }}
            </template>
            <template v-slot:[`item.valor_venta`]="{ item }">
              {{ item.valor_venta | formatMoney }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <div class="d-flex align-center">
                <v-icon small color="primary" class="mr-2" title="Editar" @click="abrirEditar(item)">fas fa-pen</v-icon>
                <BtnConfirmar
                  :disabled="item.botonEliminar"
                  icono="fas fa-trash"
                  color="error"
                  title="Eliminar"
                  :texto="`¿Eliminar el precio de <strong>${item.Descripcion || item.Modelo}</strong> (${formatDate(item.fecha_desde)} - ${formatDate(item.fecha_hasta)})?`"
                  :icon_button="true"
                  :small="true"
                  @action="eliminar(item)"
                />
              </div>
            </template>
          </v-data-table>
        </v-card>

        <!-- Sheet subir archivo -->
        <v-bottom-sheet v-model="sheetSubir">
          <v-sheet class="pa-4">
            <div class="d-flex justify-space-between align-center mb-3">
              <span class="subtitle-1">Subir precios desde Excel</span>
              <v-btn icon @click="sheetSubir = false"><v-icon>fas fa-times</v-icon></v-btn>
            </div>
            <p class="caption mb-2">
              Formato: primera fila con títulos <strong>Cod. Modelo</strong>, <strong>Modelo</strong>, <strong>Desde</strong>, <strong>Hasta</strong>, <strong>Precio</strong>. Desde/Hasta en DD/MM/AAAA.
            </p>
            <div class="mb-3">
              <v-btn
                color="info"
                small
                outlined
                @click="descargarEjemplo"
              >
                <v-icon left small>fas fa-file-download</v-icon>
                Descargar archivo de ejemplo (.xlsx)
              </v-btn>
            </div>
            <FileDropzone :files.sync="archivo" :tipos="tiposValidos" :multiple="false" :max_size="25" />
          </v-sheet>
        </v-bottom-sheet>
      </v-col>
    </v-row>

    <NuevoPrecioModeloV2
      v-model="modalNuevo"
      :precios="preciosModelos"
      @precioGuardado="onPrecioGuardado"
    />
    <NuevoPrecioModeloMasivoV2
      v-model="modalCargaMasiva"
      @guardado="buscar"
    />
    <ModalEditarPrecioModelo
      v-model="modalEditar"
      :precio="precioSeleccionado"
      @editar="onEditar"
    />
    <ModalModelosV2 v-model="modalModelos" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import BtnFiltro from '../../components/util/BtnFiltro.vue'
import FechaPicker from '../../components/util/FechaPicker.vue'
import BtnConfirmar from '../../components/util/BtnConfirmar.vue'
import FileDropzone from '../../components/util/FileDropzone.vue'
import SearchDataTable from '../../components/util/SearchDataTable.vue'
import NuevoPrecioModeloV2 from '../../components/pa/NuevoPrecioModeloV2.vue'
import NuevoPrecioModeloMasivoV2 from '../../components/pa/NuevoPrecioModeloMasivoV2.vue'
import ModalEditarPrecioModelo from '../../components/pa/ModalEditarPrecioModelo.vue'
import ModalModelosV2 from '../../components/pa/ModalModelosV2.vue'
import { format_money_round } from '../../util/utils'
import { read, utils, write } from 'xlsx'
import FileSaver from 'file-saver'

export default {
  name: 'PreciosModelosV2',
  components: {
    BtnFiltro,
    FechaPicker,
    BtnConfirmar,
    FileDropzone,
    SearchDataTable,
    NuevoPrecioModeloV2,
    NuevoPrecioModeloMasivoV2,
    ModalEditarPrecioModelo,
    ModalModelosV2
  },
  data() {
    return {
      panelFiltros: true,
      loading: false,
      buscadoRapido: '',
      sheetSubir: false,
      modalNuevo: false,
      modalCargaMasiva: false,
      modalEditar: false,
      modalModelos: false,
      archivo: [],
      tiposValidos: ['.xls', '.xlsx', '.ods'],
      preciosModelos: [],
      modelosPorFamilia: [],
      filtro: {
        empresa: null,
        marcas: [],
        modelos: [],
        desde: '',
        hasta: ''
      },
      precioSeleccionado: {},
      headers: [
        { text: 'Empresa', value: 'empresa_nombre', sortable: true },
        { text: 'Marca', value: 'marca_nombre', sortable: true },
        { text: 'Modelo', value: 'Descripcion', sortable: true },
        { text: 'Cod. Modelo', value: 'Modelo', sortable: true },
        { text: 'Desde', value: 'fecha_desde', sortable: true },
        { text: 'Hasta', value: 'fecha_hasta', sortable: true },
        { text: 'Precio', value: 'valor_venta', sortable: true, align: 'end' },
        { text: 'Acciones', value: 'actions', sortable: false, width: '120' }
      ]
    }
  },
  computed: {
    ...mapState(['familias', 'empresas']),
    marcasEmpresa() {
      if (!this.filtro.empresa || !this.filtro.empresa.id) return []
      return (this.empresas || []).filter(m => m.familia === this.filtro.empresa.id)
    },
    modelosParaFiltro() {
      let list = this.modelosPorFamilia.filter(m => !m.Inhabilitado)
      if (this.filtro.marcas && this.filtro.marcas.length > 0) {
        list = list.filter(m => this.filtro.marcas.includes(m.Empresa_id))
      }
      return list.map(m => ({ ...m, nombre: `${m.Descripcion} - ${m.Modelo}` }))
    },
    modelosParaNuevo() {
      if (!this.filtro.empresa || !this.filtro.marcas || this.filtro.marcas.length === 0) return []
      return this.modelosParaFiltro
    },
    puedeNuevo() {
      return true
    },
    puedeSubir() {
      return this.filtro.empresa && this.filtro.empresa.id && this.filtro.marcas && this.filtro.marcas.length > 0
    }
  },
  created() {
    if (this.familias && this.familias.length === 1) {
      this.filtro.empresa = this.familias[0]
      this.onEmpresaChange()
    }
  },
  methods: {
    formatDate(date, fmt = 'DD/MM/YYYY') {
      if (!date) return ''
      return moment.utc(date).format(fmt)
    },
    async onEmpresaChange() {
      this.filtro.marcas = []
      this.filtro.modelos = []
      this.modelosPorFamilia = []
      this.preciosModelos = []
      if (!this.filtro.empresa || !this.filtro.empresa.id) return
      this.loading = true
      const res = await this.$store.dispatch('preciosModelosV2/getModelosByFamilia', this.filtro.empresa.id)
      this.loading = false
      if (res.exito === 1 && res.data) {
        this.modelosPorFamilia = res.data
        const unaMarca = this.marcasEmpresa.length === 1
        if (unaMarca) this.filtro.marcas = [this.marcasEmpresa[0].id]
      } else {
        this.$store.dispatch('show_snackbar', { color: 'error', text: res.message || 'Error al cargar modelos' })
      }
    },
    onMarcasChange() {
      const ids = new Set(this.modelosParaFiltro.map(m => m.Modelo_id))
      this.filtro.modelos = (this.filtro.modelos || []).filter(id => ids.has(id))
    },
    async buscar() {
      if (!this.filtro.empresa || !this.filtro.empresa.id) {
        this.$store.dispatch('show_snackbar', { color: 'warning', text: 'Seleccione una empresa.' })
        return
      }
      this.loading = true
      const payload = {
        empresa: { id: this.filtro.empresa.id },
        marcas: (this.filtro.marcas || []).length ? this.filtro.marcas : undefined,
        modelos: (this.filtro.modelos || []).length ? this.filtro.modelos : undefined,
        desde: this.filtro.desde || undefined,
        hasta: this.filtro.hasta || undefined
      }
      const res = await this.$store.dispatch('preciosModelosV2/getPreciosModelos', payload)
      this.loading = false
      if (res.exito !== 1) {
        this.$store.dispatch('show_snackbar', { color: 'error', text: res.message || 'Error al buscar' })
        this.preciosModelos = []
        return
      }
      const raw = res.data || []
      const conFormato = raw.map(p => ({
        ...p,
        fecha_desde_fmt: p.fecha_desde ? this.formatDate(p.fecha_desde) : '',
        fecha_hasta_fmt: p.fecha_hasta ? this.formatDate(p.fecha_hasta) : '',
        botonEliminar: true
      }))
      const porModelo = {}
      conFormato.forEach(precio => {
        if (!precio.precio_id) return
        const mid = precio.modelo_id
        if (!porModelo[mid]) porModelo[mid] = []
        porModelo[mid].push(precio)
      })
      Object.keys(porModelo).forEach(mid => {
        const lista = porModelo[mid].sort((a, b) => {
          const da = moment(a.fecha_desde).valueOf()
          const db = moment(b.fecha_desde).valueOf()
          return db - da
        })
        if (lista.length) {
          const masReciente = lista[0]
          conFormato.forEach(p => {
            if (p.precio_id === masReciente.precio_id) p.botonEliminar = false
          })
        }
      })
      this.preciosModelos = conFormato.sort((a, b) => {
        const da = moment(a.fecha_desde).valueOf()
        const db = moment(b.fecha_desde).valueOf()
        return db - da
      })
    },
    limpiarFiltro() {
      this.filtro = {
        empresa: this.familias && this.familias.length === 1 ? this.familias[0] : null,
        marcas: [],
        modelos: [],
        desde: '',
        hasta: ''
      }
      this.modelosPorFamilia = []
      this.preciosModelos = []
      if (this.filtro.empresa) this.onEmpresaChange()
    },
    abrirModalNuevo() {
      this.modalNuevo = true
    },
    abrirEditar(item) {
      this.precioSeleccionado = { ...item }
      this.modalEditar = true
    },
    onPrecioGuardado(data) {
      if (data && (data.desde || data.hasta)) {
        this.filtro.desde = data.desde || this.filtro.desde
        this.filtro.hasta = data.hasta || this.filtro.hasta
      }
      this.buscar()
    },
    async eliminar(item) {
      const res = await this.$store.dispatch('preciosModelosV2/eliminarPrecioModelo', {
        precio_id: item.precio_id,
        Modelo_id: item.modelo_id
      })
      if (res.exito === 1) {
        this.$store.dispatch('show_snackbar', { color: 'success', text: res.message })
        this.preciosModelos = this.preciosModelos.filter(p => p.precio_id !== item.precio_id)
      } else {
        this.$store.dispatch('show_snackbar', { color: 'error', text: res.message || 'Error al eliminar' })
      }
    },
    onEditar(item) {
      const idx = this.preciosModelos.findIndex(p => p.precio_id === item.precio_id)
      if (idx === -1) return
      const p = this.preciosModelos[idx]
      p.fecha_desde = item.desde
      p.fecha_hasta = item.hasta
      p.fecha_desde_fmt = item.desde
      p.fecha_hasta_fmt = item.hasta
      p.valor_venta = item.precio
      p.Modelo = item.modelo
      this.$set(this.preciosModelos, idx, p)
    },
    abrirSubir() {
      if (!this.puedeSubir) {
        this.$store.dispatch('show_snackbar', { color: 'warning', text: 'Seleccione empresa y marca antes de subir.' })
        return
      }
      this.sheetSubir = true
    },
    descargar() {
      if (this.preciosModelos.length === 0) {
        this.$store.dispatch('show_snackbar', { color: 'warning', text: 'No hay datos para descargar. Aplique filtros y busque.' })
        return
      }
      const cabecera = [['Cod. Modelo', 'Modelo', 'Desde', 'Hasta', 'Precio']]
      const ws = utils.aoa_to_sheet(cabecera)
      const filas = this.preciosModelos.map(p => ({
        'Cod. Modelo': p.Modelo,
        Modelo: p.Descripcion,
        Desde: p.fecha_desde_fmt || this.formatDate(p.fecha_desde),
        Hasta: p.fecha_hasta_fmt || this.formatDate(p.fecha_hasta),
        Precio: p.valor_venta
      }))
      utils.sheet_add_json(ws, filas, {
        header: ['Cod. Modelo', 'Modelo', 'Desde', 'Hasta', 'Precio'],
        skipHeader: true,
        origin: -1
      })
      const wb = utils.book_new()
      utils.book_append_sheet(wb, ws, 'Precios modelos')
      const wbout = write(wb, { bookType: 'xlsx', type: 'array' })
      const nombre = `Precios_modelos_${moment().format('YYYY-MM-DD')}.xlsx`
      FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), nombre)
      this.$store.dispatch('show_snackbar', { color: 'success', text: 'Descarga iniciada.' })
    },
    descargarEjemplo() {
      const cabecera = [['Cod. Modelo', 'Modelo', 'Desde', 'Hasta', 'Precio']]
      const ejemplos = [
        { 'Cod. Modelo': '1ED43 015 2026', Modelo: '	MONTANA 1.2T LT AT', Desde: '01/01/2025', Hasta: '31/12/2025', Precio: 45000000 },
        { 'Cod. Modelo': '1CSLSUD415N09Q', Modelo: 'AIRCROSS 1.3 FEEL PK MY26.5', Desde: '01/02/2025', Hasta: '30/06/2025', Precio: 38000000 }
      ]
      const ws = utils.aoa_to_sheet(cabecera)
      utils.sheet_add_json(ws, ejemplos, {
        header: ['Cod. Modelo', 'Modelo', 'Desde', 'Hasta', 'Precio'],
        skipHeader: true,
        origin: -1
      })
      const wb = utils.book_new()
      utils.book_append_sheet(wb, ws, 'Plantilla')
      const wbout = write(wb, { bookType: 'xlsx', type: 'array' })
      const nombre = 'Plantilla_precios_modelos_ejemplo.xlsx'
      FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), nombre)
      this.$store.dispatch('show_snackbar', { color: 'success', text: 'Plantilla de ejemplo descargada.' })
    }
  },
  filters: {
    formatMoney(v) {
      return format_money_round(v)
    }
  },
  watch: {
    archivo: {
      async handler(files) {
        if (!files || files.length === 0) return
        const file = files[0]
        const reader = new FileReader()
        reader.onload = async e => {
          try {
            const data = new Uint8Array(e.target.result)
            const workbook = read(data, { type: 'array' })
            const sheetName = workbook.SheetNames[0]
            const worksheet = workbook.Sheets[sheetName]
            const jsonData = utils.sheet_to_json(worksheet, { raw: true })
            const preciosMod = jsonData.map(row => {
              const Cod = row['Cod. Modelo'] ?? row['Cod. modelo'] ?? row.codModelo
              const Mod = row['Modelo'] ?? row.Descripcion
              const Desde = row['Desde'] ?? row.fecha_desde
              const Hasta = row['Hasta'] ?? row.fecha_hasta
              const Precio = row['Precio'] ?? row.valor_venta
              return {
                Modelo: Cod,
                Descripcion: Mod,
                fecha_desde: typeof Desde === 'string' ? Desde : (Desde && moment(Desde).isValid() ? moment(Desde).format('DD/MM/YYYY') : ''),
                fecha_hasta: typeof Hasta === 'string' ? Hasta : (Hasta && moment(Hasta).isValid() ? moment(Hasta).format('DD/MM/YYYY') : ''),
                valor_venta: Number(Precio) || 0
              }
            }).filter(p => p.Modelo && p.valor_venta > 0)
            const existentes = this.preciosModelos
            const paraEnviar = preciosMod.filter(nuevo => {
              const mismos = existentes.filter(e => String(e.Modelo).trim() === String(nuevo.Modelo).trim())
              if (mismos.length === 0) return true
              const d = moment(nuevo.fecha_desde, 'DD/MM/YYYY')
              const h = moment(nuevo.fecha_hasta, 'DD/MM/YYYY')
              const solapa = mismos.some(e => {
                const ed = moment(e.fecha_desde_fmt || e.fecha_desde, 'DD/MM/YYYY')
                const eh = moment(e.fecha_hasta_fmt || e.fecha_hasta, 'DD/MM/YYYY')
                return !(h.isBefore(ed) || d.isAfter(eh))
              })
              return !solapa
            })
            if (paraEnviar.length === 0) {
              this.$store.dispatch('show_snackbar', { color: 'warning', text: 'No hay filas nuevas o los períodos ya existen.' })
              this.archivo = []
              return
            }
            this.loading = true
            const res = await this.$store.dispatch('preciosModelosV2/postPreciosMasivo', paraEnviar)
            this.loading = false
            if (res.exito === 1) {
              this.sheetSubir = false
              this.archivo = []
              this.$store.dispatch('show_snackbar', { color: 'success', text: res.message || 'Precios insertados.' })
              this.buscar()
            } else {
              this.$store.dispatch('show_snackbar', { color: 'error', text: res.message || 'Error al subir' })
            }
          } catch (err) {
            this.loading = false
            this.$store.dispatch('show_snackbar', { color: 'error', text: err.message || 'Error al leer el archivo' })
          }
        }
        reader.readAsArrayBuffer(file)
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.precios-modelos-v2 .v-card__title { cursor: pointer; }
</style>
